<template>
    <div class="container mx-auto px-4 lg:px-8">
        <form id="openpay-tokenization-form" class="flex items-center min-h-80 pb-10" @submit.prevent="tokenizeCard">
            <div class="grid xl:grid-cols-8 md:grid-cols-5 rounded-xl shadow-md w-full">
                <aside
                    class="bg-register bg-cover bg-no-repeat xl:col-span-3 md:col-span-2 rounded-l-xl md:px-8 hidden md:block"
                >
                    <div class="relative h-full">
                        <div class="absolute top-0 left-0 mt-16">
                            <svg xmlns="http://www.w3.org/2000/svg" height="20" class="block" viewBox="0 0 236 41.4">
                                <path
                                    fill="#64d877"
                                    d="M7.4 39.3C5 37.9 3.1 36 1.9 33.7S0 28.8 0 25.9c0-2.7.6-5.4 1.9-7.7s3.1-4.3 5.4-5.6 5-1.9 8.1-1.9c3.1 0 5.8.8 8.1 2.1s4.3 3.3 5.4 5.6c1.4 2.3 1.9 4.8 1.9 7.7s-.6 5.4-1.9 7.7c-1.4 2.3-3.1 4.3-5.4 5.6-2.3 1.4-5.2 1.9-8.1 1.9-3 .1-5.7-.7-8-2z"
                                />
                                <path
                                    fill="#fff"
                                    d="M44.1 39.9c-2.1-1-3.7-2.5-4.8-4.8-1.2-2.1-1.7-5-1.7-8.3v-16h7v15.7c0 2.7.6 4.8 1.7 6.2 1.2 1.4 2.9 2.1 5.2 2.1 2.3 0 4.1-.8 5.2-2.1 1.2-1.4 1.7-3.5 1.7-6.2V10.8h7v15.9c0 3.5-.6 6.2-1.7 8.3-1.2 2.1-2.9 3.7-4.8 4.8-1.9 1.2-4.4 1.5-7.2 1.5-3.1.1-5.5-.5-7.6-1.4zm35.4-29.1v5.4c.8-1.7 1.7-2.9 3.1-3.9s2.9-1.4 4.8-1.4h3.1v6h-2.7c-1.5 0-2.9.4-4.3 1.2-1.2.8-2.1 1.9-2.9 3.3-.6 1.5-1 3.3-1 5.2v13.7h-7V10.8h6.9zm26.9 29.1c-1.7-1-3.3-2.5-4.3-4.3v5h-6.6V0h7v11.8l-.2 3.9c1-1.7 2.3-3.1 4.1-4.1 1.7-1 3.7-1.5 5.8-1.5 2.7 0 5.2.8 7.4 2.1 2.3 1.4 4.1 3.3 5.2 5.6 1.2 2.3 1.9 5 1.9 7.9 0 2.9-.6 5.4-1.9 7.9-1.2 2.3-2.9 4.3-5.2 5.6-2.1 1.4-4.6 2.1-7.4 2.1-1.9.1-4.1-.5-5.8-1.4zm9.1-6c1.4-.8 2.3-1.7 3.1-3.3.8-1.4 1.2-3.1 1.2-4.8 0-1.7-.4-3.5-1.2-4.8-.8-1.4-1.7-2.5-3.1-3.3-1.4-.8-2.7-1.2-4.4-1.2-1.5 0-3.1.4-4.4 1.2-1.4.8-2.3 1.9-3.1 3.3-.8 1.4-1.2 2.9-1.2 4.6 0 1.7.4 3.3 1.2 4.8.8 1.4 1.9 2.5 3.1 3.3 1.4.8 2.7 1.2 4.4 1.2 1.5.1 3-.3 4.4-1zm22.6 5.4c-2.1-1.4-3.9-3.3-5-5.6-1.2-2.3-1.7-5-1.7-7.9s.6-5.4 1.7-7.9c1.4-2.3 2.9-4.3 5-5.6 2.1-1.4 4.4-2.1 7-2.1 2.3 0 4.6.6 6.4 1.5 1.9 1 3.3 2.5 4.3 4.3v-5h6.8v29.6H156v-5c-1 1.9-2.3 3.3-4.3 4.3-1.9 1-4.1 1.5-6.4 1.5-2.5 0-5-.8-7.2-2.1zm13.2-5.6c1.4-.8 2.3-1.9 3.1-3.3s1.2-2.9 1.2-4.6-.4-3.3-1.2-4.6-1.7-2.5-3.1-3.3c-1.4-.8-2.7-1.2-4.4-1.2s-3.1.4-4.4 1.2c-1.4.8-2.3 1.9-3.1 3.3s-1.2 2.9-1.2 4.8.4 3.5 1.2 4.8 1.9 2.5 3.1 3.3c1.2.8 2.9.8 4.6.8 1.5-.1 2.8-.5 4.2-1.2zm25.9-22.9v4.6c.8-1.7 2.1-2.9 4.1-4.1 1.7-1 3.9-1.5 6-1.5 3.9 0 7 1.2 8.9 3.7 1.9 2.5 2.9 6 2.9 10.8v15.9h-7V24.4c0-2.9-.6-4.8-1.7-6.2s-2.9-1.9-5-1.9c-1.4 0-2.7.4-3.9 1-1.2.8-2.1 1.7-2.9 3.1-.8 1.4-1.2 2.9-1.2 4.8v15.1h-7V10.8h6.8zm35.4 28.5c-2.3-1.4-4.3-3.3-5.6-5.6-1.4-2.3-1.9-5-1.9-7.9s.6-5.4 1.9-7.9c1.4-2.3 3.3-4.3 5.6-5.6 2.3-1.4 5-2.1 7.9-2.1 2.9 0 5.6.8 7.9 2.1 2.3 1.4 4.3 3.3 5.6 5.6 1.4 2.3 1.9 5 1.9 7.9s-.6 5.4-1.9 7.9c-1.4 2.3-3.3 4.3-5.6 5.6-2.3 1.4-5 2.1-8.1 2.1-2.7 0-5.4-.8-7.7-2.1zm12.6-5.6c1.4-.8 2.3-1.9 3.1-3.3s1.2-2.9 1.2-4.8c0-1.7-.4-3.3-1.2-4.6s-1.7-2.5-3.1-3.3c-1.4-.8-2.7-1.2-4.4-1.2s-3.1.4-4.4 1.2c-1.4.8-2.3 1.9-3.1 3.3s-1.2 2.9-1.2 4.6c0 1.7.4 3.3 1.2 4.8.8 1.4 1.7 2.5 3.1 3.3 1.4.8 2.7 1.2 4.4 1.2s3-.5 4.4-1.2z"
                                />
                            </svg>
                        </div>
                        <div class="absolute top-1/2 -translate-y-1/2 slider-register">
                            <div class="2xl:mt-16 xl:mt-8 lg:mt-6">
                                <h2 class="text-white font-bold md:text-xl lg:text-2xl xl:text-3xl">
                                    <span class="text-green-400">Urbano</span> es la plataforma de beneficios para la
                                    vida en la ciudad.
                                </h2>
                                <p class="text-white font-bold text-lg lg:text-xl mt-3 lg:mt-6">
                                    Al suscribirte tendrás acceso inmediato a:
                                </p>
                                <ul class="list-image-check text-white pl-6">
                                    <li class="mt-3 lg:mt-5">
                                        Promociones exclusivas con las mejores marcas y aliados de la salud.
                                    </li>
                                    <li class="mt-3 lg:mt-5">
                                        Boleto de regalo cada mes a los mejores eventos en el país.
                                    </li>
                                    <li class="mt-3 lg:mt-5">
                                        <span class="block">Entradas gratis para ir al cine cada mes.</span>
                                        Experiencias increíbles, como viajes en globo o días de SPA sin costo.
                                    </li>
                                </ul>
                            </div>
                            <div class="text-center xl:mt-4 mt-12">
                                <h2 class="text-white font-bold md:text-xl lg:text-2xl xl:text-3xl">Cinépolis</h2>
                                <p class="text-white">Boleto gratis en sala tradicional:</p>
                                <p v-if="movieTicket.presentable_valid_to" class="text-white text-sm">
                                    Vigencia: {{ movieTicket.presentable_valid_to }}
                                </p>
                                <img
                                    src="/images/movie.png"
                                    class="w-full object-top rounded-lg mt-3"
                                    alt="Un boleto gratis cada mes en sala tradicional"
                                />
                                <p class="text-white leading-tight mt-12">
                                    Accede cada mes y solicita tu entrada gratis al cine por ser parte de Urbano.
                                </p>
                            </div>
                            <div class="text-center xl:mt-4 mt-12">
                                <h2 class="text-white font-bold md:text-xl lg:text-2xl xl:text-3xl">
                                    Feria del vino y queso
                                </h2>
                                <div class="text-white leading-tight">
                                    <p>
                                        Te invitamos a vivir esta experiencia dentro de uno de los hoteles más bonitos
                                        de Tepoztlán.
                                    </p>
                                </div>
                                <p class="text-white text-sm mt-1">Vigencia: 17 de Noviembre de 2023</p>
                                <img
                                    src="/images/reward.jpeg"
                                    class="w-full rounded-lg mt-3"
                                    alt="Feria del vino y queso"
                                />
                                <a
                                    href="https://urbano.mobi/vivelo/feria-del-vino-y-queso"
                                    target="_blank"
                                    class="text-green-400 hover:text-green-300 transition duration-150 ease-in-out block mt-3"
                                    >Obtener boleto &#62;</a
                                >
                                <p class="text-white leading-tight mt-3">
                                    Cada mes puedes obtener un boleto gratis a eventos como este por ser parte de Urbano
                                </p>
                            </div>
                        </div>
                    </div>
                </aside>
                <section class="xl:col-span-5 md:col-span-3 md:rounded-l-none rounded-xl bg-white">
                    <div class="px-5 sm:px-8 lg:px-0 lg:w-4/5 xl:w-3/5 mx-auto py-8 lg:py-12">
                        <h1 class="text-3xl font-medium text-center text-gray-700">Método de pago</h1>
                        <p class="text-center text-gray-600 mt-2">
                            <span class="text-indigo-700">Tu cuenta se creó con éxito.</span> Agrega el método de pago.
                        </p>
                        <nav aria-label="Progress" class="mt-8">
                            <ol role="list" class="flex justify-center items-center">
                                <li class="relative pr-16 lg:pr-24">
                                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                        <div class="h-0.5 w-full bg-gray-300"></div>
                                    </div>
                                    <div
                                        class="relative flex h-10 w-10 items-center justify-center rounded-full bg-green-400"
                                    >
                                        <span class="text-white">1</span>
                                    </div>
                                </li>
                                <li class="relative pr-16 lg:pr-24">
                                    <div class="absolute inset-0 flex items-center" aria-hidden="true">
                                        <div class="h-0.5 w-full bg-gray-300"></div>
                                    </div>
                                    <div
                                        class="relative flex h-10 w-10 items-center justify-center rounded-full bg-green-400"
                                    >
                                        <span class="text-white">2</span>
                                    </div>
                                </li>
                                <li class="relative">
                                    <div
                                        class="relative flex h-10 w-10 items-center justify-center rounded-full bg-green-400"
                                    >
                                        <span class="text-white">3</span>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                        <div class="mt-8" v-if="plan.name">
                            <p class="block text-sm leading-5 text-gray-500">Plan elegido:</p>
                            <div
                                class="bg-zinc-100 flex items-center justify-between rounded-lg sm:px-10 px-6 py-3.5 mt-1.5"
                            >
                                <div>
                                    <p class="block text-sm leading-5 text-gray-600">Plan {{ plan.name }}</p>
                                    <p class="text-gray-700 text-xl font-bold mt-0.5">
                                        ${{ plan.presentable_amount }} MXN
                                    </p>
                                </div>
                                <a
                                    href="/registro-plan"
                                    class="text-blue-500 hover:text-blue-600 text-sm focus:outline-none transition ease-in-out duration-150 font-semibold"
                                    >Cambiar</a
                                >
                            </div>
                        </div>
                        <div class="mt-8">
                            <input
                                v-model="name"
                                id="card-name"
                                name="name"
                                type="text"
                                class="appearance-none block w-full px-3 py-3 border border-gray-400 rounded-md placeholder-gray-500 focus:outline-none focus:border-green-300 focus:ring focus:ring-green-300 focus:ring-opacity-30 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                placeholder="Nombre del tarjetahabiente"
                                required
                            />
                        </div>
                        <div class="relative mt-5">
                            <input
                                v-model="number"
                                id="card-number"
                                name="number"
                                type="text"
                                class="input-number appearance-none block w-full pl-3 pr-10 py-3 border border-gray-400 rounded-md placeholder-gray-500 focus:outline-none focus:border-green-300 focus:ring focus:ring-green-300 focus:ring-opacity-30 transition duration-150 ease-in-out sm:text-sm sm:leading-5 mt-2"
                                pattern="^(\d{15}|\d{16})$"
                                minlength="15"
                                maxlength="16"
                                placeholder="Número de tarjeta"
                                required
                            />
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <img :src="cardType[selectedCardType]" class="h-4" alt="Tarjeta" />
                            </div>
                        </div>
                        <div class="grid sm:grid-cols-3 gap-3 mt-5 items-end">
                            <div class="sm:col-span-2 col-span-1">
                                <label class="block text-sm leading-5 text-gray-500">Vigencia:</label>
                                <div class="grid grid-cols-2 gap-3 mt-2">
                                    <input
                                        v-model="month"
                                        id="month"
                                        name="month"
                                        type="text"
                                        class="input-number appearance-none block w-full px-3 py-3 border border-gray-400 rounded-md placeholder-gray-500 focus:outline-none focus:border-green-300 focus:ring focus:ring-green-300 focus:ring-opacity-30 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        placeholder="Mes (MM)"
                                        maxlength="2"
                                        pattern="[0-9]+"
                                        required
                                    />
                                    <input
                                        v-model="year"
                                        id="year"
                                        name="year"
                                        type="text"
                                        class="input-number appearance-none block w-full px-3 py-3 border border-gray-400 rounded-md placeholder-gray-500 focus:outline-none focus:border-green-300 focus:ring focus:ring-green-300 focus:ring-opacity-30 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        placeholder="Año (AA)"
                                        maxlength="2"
                                        pattern="[0-9]+"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="col-span-1 sm:mt-0 mt-2">
                                <input
                                    v-model="cvv"
                                    id="cvv"
                                    name="cvv"
                                    type="number"
                                    class="input-number appearance-none block w-full px-3 py-3 border border-gray-400 rounded-md placeholder-gray-500 focus:outline-none focus:border-green-300 focus:ring focus:ring-green-300 focus:ring-opacity-30 transition duration-150 ease-in-out sm:text-sm sm:leading-5 sm:mt-2"
                                    placeholder="CVV"
                                    maxlength="4"
                                    pattern="[0-9]+"
                                    required
                                />
                            </div>
                        </div>
                        <div class="flex mt-5">
                            <input
                                v-model="terms"
                                id="terms"
                                name="terms"
                                type="checkbox"
                                class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                                required
                            />
                            <label for="terms" class="ml-2 block leading-5 text-gray-500 text-sm"
                                >Acepto
                                <a
                                    href="/legales/terminos-y-condiciones"
                                    class="text-blue-500 hover:text-blue-600 focus:outline-none transition ease-in-out duration-150"
                                    target="_blank"
                                    rel="nofollow noopener noreferrer"
                                    >Términos y condiciones </a
                                >de la plataforma <span class="text-indigo-700 font-bold">Urbano</span></label
                            >
                        </div>
                        <!--
                        <div class="mt-6">
                            <p class="block text-sm leading-5 text-gray-500">Código promocional:</p>
                            <div class="mt-1.5">
                                <div class="flex items-center gap-3 relative">
                                    <input
                                        id="code-promotional"
                                        name="code"
                                        type="text"
                                        class="appearance-none block w-full pl-3 pr-28 py-3 border border-gray-400 rounded-md placeholder-gray-500 focus:outline-none focus:border-green-300 focus:ring focus:ring-green-300 focus:ring-opacity-30 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                    />
                                    <a
                                        href="#"
                                        class="absolute right-0 text-blue-500 hover:text-blue-600 text-sm focus:outline-none transition ease-in-out duration-150 font-semibold inline-block flex-shrink-0 py-2.5 px-4"
                                        >Usar código</a
                                    >
                                </div>
                                <p class="flex items-center text-gray-500 text-xs font-semibold mt-1.5">
                                    <span class="text-2xl leading-none text-green-500 mr-1">●</span> Válido
                                </p>
                                <p class="flex items-center text-gray-500 text-xs font-semibold mt-1.5">
                                    <span class="text-2xl leading-none text-orange-500 mr-1">●</span> No válido
                                </p>
                                <p class="flex items-center text-gray-500 text-xs font-semibold mt-1.5">
                                    <span class="text-2xl leading-none text-red-500 mr-1">●</span> Expirado
                                </p>
                            </div>
                        </div>
                        -->
                        <template v-if="isLoading">
                            <button
                                type="button"
                                class="btn inline-flex text-white w-full mt-6 bg-indigo-500 justify-center"
                                disabled=""
                            >
                                <svg
                                    class="motion-reduce:hidden animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        class="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        stroke-width="4"
                                    ></circle>
                                    <path
                                        class="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                Procesando...
                            </button>
                        </template>
                        <template v-else>
                            <button class="btn btn-primary block w-full mt-6">Unirme al Club</button>
                        </template>
                        <div class="grid grid-cols-12 gap-1 sm:gap-3 items-center mt-8">
                            <div class="col-span-5 sm:col-span-3 md:col-span-4">
                                <img src="/images/openpay.png" class="h-5 sm:h-6" alt="Logo de Openpay" />
                            </div>
                            <div class="col-span-7 sm:col-span-9 md:col-span-7 flex items-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    class="text-indigo-700 w-8 h-8 pr-1"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                                    />
                                </svg>
                                <p class="text-indigo-600 text-sm text-center font-bold mt-px">Sitio Seguro</p>
                            </div>
                        </div>
                        <div class="mt-5">
                            <p class="text-gray-600 text-xs">
                                Al hacer click en el botón "Unirme al Club", aceptas nuestros
                                <a
                                    href="/legales/terminos-y-condiciones"
                                    class="focus:outline-none underline transition ease-in-out duration-150"
                                    target="_blank"
                                    rel="nofollow noopener noreferrer"
                                    >Términos y condiciones</a
                                >
                                y
                                <a
                                    href="/legales/aviso-de-privacidad"
                                    class="focus:outline-none underline transition ease-in-out duration-150"
                                    target="_blank"
                                    rel="nofollow noopener noreferrer"
                                    >Aviso de privacidad</a
                                >, y declaras que tienes más de 18 años. Puedes cancelar la membresía en cualquier
                                momento desde tu cuenta online.
                            </p>
                        </div>
                    </div>
                    <div class="bg-gray-100 text-center p-3 rounded-br-xl flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 lg:h-6" viewBox="0 0 27.78 22.12">
                            <path
                                d="M17.78 16.6a4.37 4.37 0 0 0-2.22-1.66 4.31 4.31 0 0 0-2.78.06 4.61 4.61 0 0 0-1.5.87 6.36 6.36 0 0 0-6.5-2.27 6.31 6.31 0 0 0-4.75 6.13v.11a.73.73 0 0 0 .36.63 11.63 11.63 0 0 0 11.77.1 8.86 8.86 0 0 0 2.06.24 8.92 8.92 0 0 0 3.93-.91.77.77 0 0 0 .42-.64 4.43 4.43 0 0 0-.79-2.66Zm-11.45 4a10.09 10.09 0 0 1-4.82-1.2 5 5 0 0 1 1-2.63 4.82 4.82 0 0 1 8 .63 4.76 4.76 0 0 1 .57 2 10 10 0 0 1-4.74 1.22Zm7.86-1.31a7.37 7.37 0 0 1-1.56-.16 6.56 6.56 0 0 0-.53-2 2.82 2.82 0 0 1 1.18-.77 2.9 2.9 0 0 1 1.82 0 2.87 2.87 0 0 1 1.45 1.09 2.83 2.83 0 0 1 .49 1.3 7.48 7.48 0 0 1-2.84.56Zm2.16-9.92a3.12 3.12 0 0 0-4.31 0 3.048 3.048 0 0 0 4.31 4.31 3.09 3.09 0 0 0 .89-2.15 3.06 3.06 0 0 0-.88-2.14Zm-1.06 3.25a1.6 1.6 0 0 1-2.19 0 1.56 1.56 0 0 1 0-2.19 1.54 1.54 0 0 1 1.1-.43 1.58 1.58 0 0 1 1.1.45 1.56 1.56 0 0 1 .45 1.1 1.6 1.6 0 0 1-.45 1.09ZM8.95 7a3.79 3.79 0 0 0-5.24 0 3.7 3.7 0 1 0 5.24 0Zm-1.07 4.14a2.27 2.27 0 0 1-3.11 0A2.2 2.2 0 0 1 4.78 8a2.22 2.22 0 0 1 1.56-.64A2.14 2.14 0 0 1 7.88 8a2.2 2.2 0 0 1 0 3.12Z"
                            />
                            <path
                                d="M25 1h-7a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h7a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4Z"
                                style="fill: #6781e7"
                                transform="translate(-1.22 -1)"
                            />
                            <path
                                d="M18.44 4v3.54h-.65V4Zm1.4 1.45v.63h-3.45v-.63ZM21.59 8V4.22a2.37 2.37 0 0 1-1.16.63l-.13-.65a1.53 1.53 0 0 0 .34-.1c.13 0 .27-.12.41-.19l.38-.26a1.15 1.15 0 0 0 .27-.27h.63V8Zm3.57-4.68a2 2 0 0 1 .81.15 1.27 1.27 0 0 1 .54.42 1.17 1.17 0 0 1 .19.66 1.11 1.11 0 0 1-.18.63 1.08 1.08 0 0 1-.5.41 1.41 1.41 0 0 1 .63.44 1.08 1.08 0 0 1 .24.72 1.16 1.16 0 0 1-.21.7 1.37 1.37 0 0 1-.61.46 2.28 2.28 0 0 1-.91.16 2.38 2.38 0 0 1-.93-.16 1.46 1.46 0 0 1-.6-.46 1.23 1.23 0 0 1 0-1.42 1.47 1.47 0 0 1 .65-.44 1.17 1.17 0 0 1-.5-.4 1.17 1.17 0 0 1-.18-.64 1.09 1.09 0 0 1 .19-.66 1.16 1.16 0 0 1 .54-.42 2 2 0 0 1 .83-.15Zm0 .63a.93.93 0 0 0-.6.18.64.64 0 0 0-.22.5.59.59 0 0 0 .23.49.9.9 0 0 0 .59.18.89.89 0 0 0 .58-.18.59.59 0 0 0 .26-.49.61.61 0 0 0-.22-.5.87.87 0 0 0-.62-.13Zm0 3.49a1.35 1.35 0 0 0 .52-.09.71.71 0 0 0 .32-.27.68.68 0 0 0 .12-.4.72.72 0 0 0-.12-.42.76.76 0 0 0-.33-.26 1.29 1.29 0 0 0-.51-.09 1.38 1.38 0 0 0-.52.09.79.79 0 0 0-.35.26.72.72 0 0 0-.12.42.68.68 0 0 0 .12.4.71.71 0 0 0 .34.27 1.44 1.44 0 0 0 .53.09Z"
                                style="fill: #fff"
                                transform="translate(-1.22 -1)"
                            />
                        </svg>
                        <p class="text-indigo-700 text-xs lg:text-sm ml-2 mt-px">Solo para mayores de edad</p>
                    </div>
                </section>
            </div>
        </form>
    </div>
</template>

<script>
import Form from '../support/Form';
import sweetAlert from 'sweetalert';

export default {
    props: {
        publicKey: String,
        openpayId: String,
        sandboxMode: Boolean,
        movieTicket: {
            type: Object,
            required: false,
        },
        plan: {
            type: Object,
            required: false,
        },
        reward: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            form: new Form({
                token: '',
                name: '',
                device_session_id: '',
            }),
            name,
            token: '',
            number: '',
            month: '',
            year: '',
            cvv: '',
            terms: false,
            isLoading: false,
            cardType: {
                default: '/images/card.svg',
                Visa: '/images/visa.png',
                Mastercard: '/images/mastercard.png',
            },
            selectedCardType: 'default',
        };
    },

    computed: {
        //
    },

    mounted() {
        OpenPay.setId(this.openpayId);
        OpenPay.setApiKey(this.publicKey);
        OpenPay.setSandboxMode(this.sandboxMode);
    },

    methods: {
        submit() {
            this.form.device_session_id = OpenPay.deviceData.setup();
            this.form.name = this.name;

            this.form
                .post('/registro-tarjeta')
                .then((response) => {
                    if (typeof response.status === 'object') {
                        sweetAlert('Éxito', 'Tu suscripción fue generada exitosamente.', 'success');

                        setTimeout(function () {
                            location.href = '/registro-confirmacion';
                        }, 2000);
                    } else {
                        this.isLoading = false;

                        throw new Error(response.status);
                    }
                })
                .catch((error) => {
                    this.isLoading = false;

                    sweetAlert('Error', 'La tarjeta fue rechazada.', 'error');
                });
        },

        tokenizeCard() {
            this.isLoading = true;

            return OpenPay.token.create(
                {
                    card_number: this.number,
                    holder_name: this.name,
                    expiration_month: this.month,
                    expiration_year: this.year,
                    cvv2: this.cvv,
                },
                this.onSuccess,
                this.onError
            );
        },

        onSuccess(response) {
            this.form.token = response.data.id;

            this.submit();
        },

        onError(error) {
            this.isLoading = false;

            sweetAlert('Error', 'La tarjeta fue rechazada por el banco.', 'error');
        },
    },
    watch: {
        number: function (newVal, oldVal) {
            let type = OpenPay.card.cardType(this.number);

            switch (type) {
                case 'Visa':
                case 'Mastercard':
                    this.selectedCardType = type;
                    break;

                default:
                    this.selectedCardType = 'default';
                    break;
            }
        },
    },
};
</script>
